module.exports = __webpack_public_path__ + "img/1600-1_YR_2022_Globe.8ffb6ef9.png";